import type { ContentPage } from "@/lib/content/types";

export const assignmentRule: ContentPage = {
  slug: "process-management/assignment-rule",
  template: "hrmsFeature",
  seo: {
    title: "Lead Assignment Rules - Auto-Route Leads to Reps | GetBiz CRM",
    description:
      "Automatically assign leads and records to the right rep with GetBiz CRM assignment rules — by territory, product or round-robin — so nothing sits unowned.",
    keywords: [
      "lead assignment rules",
      "lead routing software",
      "round robin lead assignment",
      "territory management",
      "CRM assignment",
      "auto assign leads",
    ],
    ogImage: "/assets/data/seoimages/assignment-rule.webp",
  },
  leaf: {
    hero: {
      caption: "Assignment Rule",
      title: "Send Every Lead to the Right Rep, Instantly",
      description:
        "Auto-assign leads and records by territory, product, workload or round-robin — so every lead gets a fast, fair owner and none slip through the cracks.",
      h1: "caption",
    },
    split: {
      title: "Fair, Fast, Automatic Ownership",
      bullets: [
        { title: "Rule-based Routing", description: "Assign by any field — region, product, source." },
        { title: "Round-robin", description: "Distribute leads evenly across the team." },
        { title: "Workload Balancing", description: "Route by capacity so no one is overloaded." },
        { title: "Instant Handoff", description: "Owners are notified the moment a lead lands." },
      ],
      image: "/assets/images/img/product/crm/ownership-assignment-rule.webp",
      imageAlt: "GetBiz CRM assignment rules",
    },
    cardsHeading: {
      title: "More Process Management Tools",
      description: "Assignment Rule works with the rest of GetBiz CRM process management.",
    },
    cards: [
      { title: "Lead Scoring", href: "/crm-software/process-management/lead-scoring/", description: "Route your highest-scoring leads first.", image: "/assets/images/img/product/crm/lead-scoring.webp", imageAlt: "CRM lead scoring" },
      { title: "Sales Blueprint", href: "/crm-software/process-management/sales-blueprint/", description: "Assign owners at each stage of your process.", image: "/assets/images/img/product/crm/sales-blueprint.webp", imageAlt: "CRM sales blueprint" },
      { title: "Approval Process", href: "/crm-software/process-management/approval-process/", description: "Pair assignment with automated approvals.", image: "/assets/images/img/product/crm/approval-process.webp", imageAlt: "CRM approval process" },
      { title: "Review Process", href: "/crm-software/process-management/review-process/", description: "Add review steps after assignment.", image: "/assets/images/img/product/crm/review-process.webp", imageAlt: "CRM review process" },
    ],
    testimonials: { title: "No lead left behind", description: "See why teams automate assignment in GetBiz CRM." },
    bookDemoTitle: "Route every lead automatically.",
    relatedBlogs: "slug",
    relatedBlogsKeyword: "lead-assignment-rules-guide, lead-routing-best-practices",
    metaKey: "assignment-rule",
  },
  sections: [],
};
